import {
  type CartControllerCartShippingDetailV2,
  type CartControllerSellerGroupV2,
} from 'types/api/cart'

function showFreeShippingThreshold(
  shippingDetail: CartControllerCartShippingDetailV2,
  sellerSubAmount: number
): boolean {
  return (
    shippingDetail.shippingCost > 0 ||
    sellerSubAmount >= shippingDetail.freeShippingThreshold
  )
}
function mapShippingDetail(
  seller: CartControllerSellerGroupV2,
  shippingDetails: CartControllerCartShippingDetailV2[]
): CartControllerSellerGroupV2 {
  const offerIds = seller?.groupEntries
    .flatMap(group => group.items)
    .map(item => item.offerId)
  const shippingDetail = shippingDetails.find(
    (detail: CartControllerCartShippingDetailV2) =>
      detail.offerIds.find(item => offerIds.lastIndexOf(item) !== -1)
  )
  return { ...seller, shippingDetail }
}
export { showFreeShippingThreshold, mapShippingDetail }
